<template>
    <div class="form-dialog">
        <el-dialog :visible="true" center @close="closeDialog" :append-to-body="true" :close-on-click-modal="false">
            <div class="mask"></div>
            <div class="freeTrialForm">
                <div class="leftBanner">
                    <img src="../assets/cloudHome/pic_tk_content.png" alt="" />
                </div>
                <div class="rightForm" v-if="!registerSuccess">
                    <p class="title mb-8">
                        <span style="color: #ff5d00">免费试用</span>
                        <span>上上参谋企业版</span>
                    </p>
                    <el-form class="form" size="medium" :model="form" :rules="rules" ref="submitForm" label-width="99px" label-position="left">
                        <el-form-item label="品牌名称" prop="brandName">
                            <el-input v-model="form.brandName" maxlength="50" placeholder="请输入品牌、公司或项目名称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属行业" prop="mainIndustry">
                            <el-select v-model="form.mainIndustry" placeholder="请选择所属行业" style="width: 100%">
                                <el-option v-for="(item, key) in listArr" :key="key" :label="item.name" :value="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司所在地" prop="location">
                            <el-cascader
                                v-model="form.location"
                                :show-all-levels="false"
                                :props="{ value: 'name', label: 'name' }"
                                :options="cityOptions"
                                placeholder="请选择您公司总部所在城市"
                                style="width: 100%"
                            />
                        </el-form-item>
                        <el-form-item label="计划开店数" prop="planStoreNum">
                            <el-select :popper-append-to-body="false" v-model="form.planStoreNum" placeholder="请选择计划开店数" style="width: 100%" clearable>
                                <el-option label="1-100家门店" :value="1"></el-option>
                                <el-option label="100-500家门店" :value="2"></el-option>
                                <el-option label="500-1000家门店" :value="3"></el-option>
                                <el-option label="1000家以上门店" :value="4"></el-option>
                                <el-option label="无拓展计划" :value="5"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="您的称呼" prop="contactName">
                            <el-input v-model="form.contactName" maxlength="20" placeholder="请填写您的名字"></el-input>
                        </el-form-item>
                        <el-form-item label="您的岗位" prop="position">
                            <el-input v-model="form.position" maxlength="20" placeholder="请输入您的岗位"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号" prop="contactTel">
                            <el-input v-model="form.contactTel" maxlength="11" placeholder="请输入您的手机号"></el-input>
                        </el-form-item>
                        <template v-if="form.brandName && form.mainIndustry && form.location.length && form.planStoreNum && form.contactName && form.position && form.contactTel.length === 11">
                            <template v-if="windowType === 'PC端'">
                                <el-form-item label="验证码" prop="code">
                                    <AlyRange v-if="!sliderStatus" :width="windowType === 'PC端' ? 354 : 300" ref="rangeRef" @success="rangeSuccess" />
                                    <el-input v-else v-model="form.code" maxlength="6" placeholder="请填写验证码">
                                        <el-button
                                            slot="append"
                                            :class="{
                                                'code-btn-active': /^1\d{10}$/.test(String(form.contactTel)) && !isCode
                                            }"
                                            :disabled="!/^1\d{10}$/.test(String(form.contactTel)) || !!isCode"
                                            class="code-btn"
                                        >
                                            <span v-if="isCode">获取验证码{{ this.isCode }}</span>
                                            <span v-else @click="sliderStatus = false">重新获取验证码</span>
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <div v-if="!sliderStatus" style="height: 34px;position: relative;">
                                    <AlyRange :width="windowType === 'PC端' ? 354 : 300" ref="rangeRef" @success="rangeSuccess" />
                                </div>
                                <el-form-item label="验证码" prop="code" v-else>
                                    <el-input v-model="form.code" maxlength="6" placeholder="请填写验证码">
                                        <el-button
                                            slot="append"
                                            :class="{
                                                'code-btn-active': /^1\d{10}$/.test(String(form.contactTel)) && !isCode
                                            }"
                                            :disabled="!/^1\d{10}$/.test(String(form.contactTel)) || !!isCode"
                                            class="code-btn"
                                        >
                                            <span v-if="isCode">获取验证码{{ this.isCode }}</span>
                                            <span v-else @click="sliderStatus = false">重新获取验证码</span>
                                        </el-button>
                                    </el-input>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                    <div class="agreement mt-16">
                        <el-checkbox v-model="agreementChecked"></el-checkbox>
                        <div class="agreementText ml-12">
                            我已阅读并同意
                            <span class="link" @click="gotoAgreement(1)">《上上参谋企业版服务协议》</span>
                            ，并生成
                            <span class="link" @click="gotoAgreement(2)">《品牌方隐私声明（示例）》</span>
                        </div>
                    </div>
                    <el-button
                        :disabled="true"
                        class="sbumitBtn1"
                        @click="freeTrial"
                        v-if="
                            !(
                                sliderStatus &&
                                form.brandName &&
                                form.mainIndustry &&
                                form.location.length &&
                                form.planStoreNum &&
                                form.contactName &&
                                form.position &&
                                form.contactTel.length === 11 &&
                                form.code
                            )
                        "
                    >
                        立即提交
                    </el-button>
                    <el-button v-else @click="freeTrial" class="sbumitBtn">立即提交</el-button>
                </div>
                <div class="rightSuccess" v-else>
                    <i class="el-icon-close right-success-close" @click="closeDialog"></i>
                    <div class="right-success-title">已收到您的申请</div>
                    <img class="right-success-img" src="../assets/cloudHome/sw_wechat.jpg" alt="" />
                    <div class="right-success-tips">
                        扫码添加企业微信，专业顾问在线为您答疑
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { eventRegistrationSEM, registerSendSms, listOpenCityData } from '@/api/saas';
import AlyRange from './AlyRange';
const opt = {
    sessionId: '',
    sig: '',
    token: ''
};
export default {
    name: 'formDialog',
    data() {
        var isPhoneNo = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请填写您的手机号'));
            } else if (!/^1\d{10}$/.test(String(value))) {
                callback(new Error('请填写正确的手机号'));
            } else {
                callback();
            }
        };
        return {
            form: {
                brandName: '', //品牌名称
                contactTel: '', //手机号
                planStoreNum: '', //计划开店数
                contactName: '', //您的称呼
                clientSource: 'PC', //PC或H5
                promote: '', //来源，百度还是注册
                code: '', //验证码
                searchSource: 2, //百度的1，注册的2
                mainIndustry: '', //所属行业
                location: [], // 所在城市
                position: '' //您的岗位
            },
            isCode: 0, //验证码
            agreementChecked: false,
            loading: false,
            rules: {
                planStoreNum: [
                    {
                        required: true,
                        message: '请选择计划开店数',
                        trigger: ['blur', 'change']
                    }
                ],
                brandName: [
                    {
                        required: true,
                        message: '请输入品牌、公司或项目名称',
                        trigger: 'blur'
                    }
                ],
                contactTel: [{ required: true, validator: isPhoneNo, trigger: 'blur' }],
                contactName: [{ required: true, message: '请填写您的名字', trigger: 'blur' }],
                code: [{ required: true, message: '请填写验证码', trigger: 'blur' }],
                mainIndustry: [{ required: true, message: '请选择所属行业', trigger: ['blur', 'change']}],
                location: [{ required: true, message: '请选择您公司所在地', trigger: ['blur', 'change']}],
                position: [{ required: true, message: '请输入您的岗位', trigger: 'blur' }]
            },
            registerSuccess: false,
            btnLoading: false,
            accountInfo: {},
            sliderStatus: false, // 防人机验证状态
            rangeOpt: {
                // 滑块校验参数
                scene: 'login',
                ...opt
            },
            listArr: [
                { name: '餐饮', value: 'W01' },
                { name: '零售', value: 'W02' },
                { name: '教育培训', value: 'W06' },
                { name: '休闲娱乐', value: 'W08' },
                { name: '生活服务', value: 'W16' },
                { name: '丽人', value: 'W12' },
                { name: '酒旅', value: 'W07' },
                { name: '医疗健康', value: 'W10' },
                { name: '汽车服务', value: 'W11' },
                { name: '运动健身', value: 'W13' }
            ],
            windowType: '', //判断是手机端还是pc端
            timer: null,
            cityOptions: [] // 省市区数据
        };
    },
    methods: {
        loadData() {
            listOpenCityData().then(res => {
                let result = res.data || [];
                result.forEach(item => {
                    if (['810000', '820000'].includes(item.code)) {
                        item.children = [
                            {
                                code: item.code,
                                name: item.name
                            }
                        ];
                    }
                    let child = item.children || [];
                    if (child.length) {
                        child.forEach(ele => {
                            delete ele.children;
                        });
                    }
                });
                this.cityOptions = result;
            });
        },
        freeTrial() {
            this.$refs.submitForm.validate(valid => {
                if (!valid) {
                    console.log('error submit!!');
                    return false;
                } else {
                    if (!this.agreementChecked) {
                        this.$message({
                            message: '请查看并勾选我已阅读',
                            type: 'warning',
                            center: true
                        });
                        return;
                    }
                    // // 百度sem推广落地页点进来注册的
                    if (this.$route.query.promote && this.$route.query.promote != '') {
                        this.form.promote = this.$route.query.promote;
                    }
                    if (this.$route.query.searchSource && this.$route.query.searchSource != '') {
                        // 1代表搜索来源是百度
                        this.form.searchSource = this.$route.query.searchSource;
                    }
                    let params = {
                        brandName: this.form.brandName, //品牌名称
                        contactTel: this.form.contactTel, //手机号
                        planStoreNum: this.form.planStoreNum, //计划开店数
                        contactName: this.form.contactName, //您的称呼
                        clientSource: this.form.clientSource, //PC或H5
                        promote: this.form.promote, //来源，百度还是注册
                        code: this.form.code, //验证码
                        searchSource: this.form.searchSource, //百度的1，注册的2
                        mainIndustry: this.form.mainIndustry, //所属行业
                        location: this.form.location.join('/'), //公司所在地
                        position: this.form.position, //您的岗位
                        channelCode: ''
                    };
                    eventRegistrationSEM(params)
                        .then(res => {
                            this.loading = false;
                            if (res.code === 0) {
                                this.registerSuccess = true;
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'warning'
                                });
                                this.sliderStatus = false;
                                this.form.code = '';
                            }
                            clearInterval(this.timer);
                            this.isCode = 0;
                        })
                        .catch(e => {
                            this.loading = false;
                        });
                }
            });
        },
        gotoAgreement(type) {
            if (type == 1) {
                window.open('https://saas.sscanmou.com/static/userAgreement.html', '_blank');
            } else {
                window.open('https://saas.sscanmou.com/static/privacyAgreement.html', '_blank');
            }
        },
        closeDialog() {
            this.$emit('close');
        },
        // 获取短信验证码
        getCode(item) {
            this.isCode = 60;
            this.timer = setInterval(() => {
                this.isCode--;
                if (!this.isCode) {
                    clearInterval(this.timer);
                    this.isCode = 0;
                }
            }, 1000);
            let from = JSON.parse(JSON.stringify(Object.assign({ phone: this.form.contactTel }, item)));
            registerSendSms(from).then(res => {
                if (res.code === 0) {
                    this.$message({
                        message: '发送短信验证码成功',
                        type: 'success',
                        center: true
                    });
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'warning'
                    });
                }
            });
        },
        //阿里云滑块验证回调函数
        rangeSuccess(item) {
            let obj = JSON.parse(JSON.stringify(Object.assign(this.rangeOpt, item)));
            this.sliderStatus = true;
            this.getCode(obj);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (to.query.phone && to.query.phone == vm.$store.getters.trialAccountPhone) {
                // 通过第一步注册
                next();
            } else {
                next('/login?type=register');
            }
        });
    },
    components: {
        AlyRange
    },
    mounted() {
        var is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
        if (is_mobi) {
            this.windowType = '手机端';
        } else {
            this.windowType = 'PC端';
        }
        this.loadData();
    }
};
</script>
<style lang="less">
.my-pc {
    // 解决弹出框中下拉框位置偏移问题
    .el-select-dropdown {
        position: absolute !important;
        top: 35px !important;
        left: 0px !important;
    }
}
.el-form-item__error {
    margin-left: 0 !important;
}
</style>
<style lang="less" scoped>
::v-deep .el-dialog__header {
    padding: 0;
}
::v-deep .el-dialog__body {
    padding: 0;
}
::v-deep .el-dialog {
    padding: 0;
    width: 95%;
    max-width: 734px;
}
::v-deep .el-popper {
    position: fixed;
    top: inherit !important;
}
.freeTrialForm {
    display: flex;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    .rightForm {
        flex: 1;
        background-color: #fff;
        border-radius: 0px 8px 8px 0px;
        padding: 0 16px 20px;

        .title {
            font-size: 26px;
            font-weight: 600;
            font-family: PingFangSC-Semibold, PingFang SC;
            color: #303133;
            line-height: 37px;
            position: relative;
            margin: 32px 0;
        }
        .form {
            ::v-deep .el-form-item__label {
                text-align: left;
                width: 99px;
                font-size: 16px;
                font-weight: 500;
                color: #121622;
                line-height: 32px;
                margin-bottom: 8px;
                padding: 0;
                font-family: PingFangSC-Medium, PingFang SC;
            }
            ::v-deep .el-input__inner {
                height: 40px !important;
                line-height: 40px !important;
                border: none !important;
                background: #f7f8fa !important;
                border-radius: 4px !important;
                padding: 0 16px !important;
                border: 2px solid transparent !important;
                color: #333 !important;
                &:focus {
                    border-color: #347fff !important;
                }
            }
            ::v-deep .el-form-item {
                margin-bottom: 20px;
                &:last-child {
                    margin-bottom: 0px;
                }
            }
            ::v-deep .el-form-item__error {
                margin-left: 99px;
            }
            .code-btn {
                color: #fff;
                height: 40px;
                background-color: #bbbbbb;
            }
            .code-btn-active {
                background: #ff5d00;
                border: 1px solid #ff5d00;
                color: #fff;
            }
        }
        .agreement {
            display: flex;
            margin-bottom: 20px;
            margin-top: 20px;
            font-size: 10px;
            color: #101e3d;
            label {
                margin-top: -2px;
                margin-bottom: 0;
            }
            .agreementText {
                margin-left: 5px;
                flex: 1;
                overflow: hidden;
                word-wrap: break-word;
                word-break: break-all;
                .link {
                    color: #007eff;
                    cursor: pointer;
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
        .sbumitBtn {
            width: 100%;
            height: 48px;
            background-color: #ff5d00;
            color: #fff;
            font-size: 16px;
            border-radius: 24px;
            box-shadow: 0px 8px 24px 0px rgba(255, 93, 0, 0.2);
        }
        .sbumitBtn1 {
            width: 100%;
            height: 48px;
            background-color: #bbbbbb !important;
            color: #fff !important;
            font-size: 16px;
            border-radius: 24px;
        }
    }
    .leftBanner {
        width: 250px;
        background-image: url('../assets/cloudHome/pic_tk.png');
        background-size: 100% 100%;
        position: relative;
        img {
            width: 226px;
            position: absolute;
            left: 50%;
            top: 50px;
            transform: translateX(-50%);
        }
    }
    .rightSuccess {
        width: 484px;
        height: 657px;
        background: #ffffff;
        border-radius: 0px 8px 8px 0px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;

        .right-success-title {
            width: 182px;
            height: 37px;
            font-size: 26px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #ff5d00;
            line-height: 37px;
            margin-top: 139px;
            margin-bottom: 24px;
        }
        .right-success-img {
            width: 284px;
            height: 284px;
            margin-bottom: 15px;
        }
        .right-success-tips {
            width: 266px;
            height: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #121622;
            line-height: 20px;
        }
        .right-success-close {
            position: absolute;
            top: 24px;
            right: 24px;
            width: 16px !important;
            height: 16px !important;
            color: rgba(#000000, 0.25);
        }
    }
}
</style>
<style lang="less" scoped>
@media screen and(max-width:734px) {
    .freeTrialForm .leftBanner {
        display: none;
    }
}
</style>
